import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";
import { reportTableStyles } from "../Reports/reportTableStyles";

const WorkorderConsolidated = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    action_type: "Fetch",
  });

  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");

  /* 🔹 Handle Input */
  const handleInput = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  /* =====================================================
   * 🔹 FETCH CONSOLIDATED REPORT
   * =====================================================
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get(API_BASE_URL + "/workorder_consolidated_list", {
        params: filters,
      });

      const formatted = res.data.data.map((row) => ({
        asset_code: row[0],
        asset_name: row[1],
        workorder_cost: row[2],
        asset_cost: row[3],
        supplier_name: row[4],
        manufacture_name: row[5],
      }));

      setRecords(formatted);

      toast.success("Workorder Consolidated Report Loaded!", {
        position: "bottom-right",
      });
    } catch {
      toast.error("Failed to load consolidated report", {
        position: "bottom-right",
      });
    }
  };

  /* =====================================================
   * 🔹 CSV EXPORT
   * =====================================================
   */
  const downloadCSV = () => {
    if (!records.length) {
      toast.error("No records available");
      return;
    }

    const header = [
      "Asset Code",
      "Asset Name",
      "Workorder Cost",
      "Asset Cost",
      "Supplier Name",
      "Manufacture Name"
    ];

    const clean = (v) => (v ? String(v).replace(/,/g, " ").trim() : "");

    const rows = records.map((r) => [
      clean(r.asset_code),
      clean(r.asset_name),
      clean(r.workorder_cost),
      clean(r.asset_cost),
      clean(r.supplier_name),
      clean(r.manufacture_name),
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [header, ...rows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "Workorder_Consolidated_Report.csv";
    document.body.appendChild(link);
    link.click();
  };

  /* =====================================================
   * 🔹 DATATABLE COLUMNS
   * =====================================================
   */
 const columns = [
  { name: "Asset Code", selector: (row) => row.asset_code, sortable: true },
  { name: "Asset Name", selector: (row) => row.asset_name, sortable: true },

  {
    name: "Workorder Cost",
    sortable: false,
    cell: (row) => (
      <div
        style={{ width: "150px" }}   // adjust width same as screenshot
        dangerouslySetInnerHTML={{ __html: row.workorder_cost }}
      />
    ),
  },

  { name: "Asset Cost", selector: (row) => row.asset_cost, sortable: true },
  { name: "Supplier Name", selector: (row) => row.supplier_name, sortable: true },
  { name: "Manufacture Name", selector: (row) => row.manufacture_name, sortable: true },
];

  /* 🔹 Search Filter */
  const filteredData = records.filter((item) =>
    `${item.asset_code} ${item.asset_name} ${item.supplier_name} ${item.manufacture_name}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <ToastContainer />

      {/* 🔹 HEADER MENU */}
      <div className="mb-3 d-flex gap-2">
        <a href="/Assetreport" className="btn btn-outline-secondary btn-sm">Asset Report</a>
        <a href="/workorder" className="btn btn-outline-secondary btn-sm">Workorder Report</a>
        <a href="/consolidated" className="btn btn-info btn-sm">Workorder Consolidated Report</a>
      </div>

      {/* 🔹 FILTER CARD */}
      <div className="card shadow-sm mb-4">
        <div className="card-header">
          <h6 className="mb-0">Workorder Consolidated Report Filter</h6>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              {/* From Date */}
              <div className="col-md-3">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleInput}
                />
              </div>

              {/* To Date */}
              <div className="col-md-3">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleInput}
                />
              </div>

              {/* Action */}
              <div className="col-md-2">
                <label>Action</label>
                <select
                  className="form-control"
                  name="action_type"
                  value={filters.action_type}
                  onChange={handleInput}
                >
                  <option value="Fetch">Show</option>
                </select>
              </div>

              {/* Submit */}
              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-primary w-100">Get</button>
              </div>

            </div>
          </form>
        </div>
      </div>

      {/* 🔹 TABLE SECTION */}
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <button className="btn btn-outline-secondary btn-sm" onClick={downloadCSV}>
            CSV
          </button>

          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search..."
            style={{ width: "200px" }}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            striped
            highlightOnHover
            fixedHeader
            fixedHeaderScrollHeight="60vh"
            customStyles={reportTableStyles}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkorderConsolidated;
